import { useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import API from "../api";

import { useLocation } from "react-router-dom";
import RegisterUser from "../components/registerUser";
import VerifyOtp from "../components/verifyOtp";

export default function Multistep() {
  const toast = useToast();
  const [step, setStep] = useState(1);
  const location = useLocation();
  const [config, setConfig] = useState({
    email: "",
    password: "",
    name: "",
    companyName: "",
    typeOfBusiness: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);
  const handleClick = () => setShow(!show);
  const onChange = (key, value) => {
    if (errors[key]) {
      const errorObj = { ...errors };
      delete errorObj[key];
      setErrors({ ...errorObj });
    }
    if (key === "phone") {
      const updatedValue = value.replace(/^0+|[^0-9]/g, "");
      setConfig({
        ...config,
        [key]: updatedValue,
      });
      return true;
    }
    setConfig({
      ...config,
      [key]: value,
    });
  };

  const handleGoBack = () => {
    setStep(1);
  };
  const sendOtpAndRegister = async () => {
    const registerData = { ...config };
    if (registerData?.otp) {
      delete registerData.otp;
    }
    return API("/auth/register", "POST", { ...registerData });
  };

  const resendOtp = async () => {
    const { email, phone } = config;
    return API("/auth/resend-register-otp", "POST", { email, phone });
  };

  const validateStepOne = (config) => {
    let objErrors = {};
    if (config.name === "" || !config.name) {
      objErrors.name = "Name is required";
    } else if (
      config.phone === "" ||
      !config.phone ||
      config?.phone?.length !== 10
    ) {
      objErrors.phone = "Valid Phone Number is required";
    } else if (config.email === "" || !config.email) {
      objErrors.email = "Email is required";
    } else if (!config.password || config.password === "") {
      objErrors.password = "Password is required";
    } else if (!config.typeOfBusiness || config.typeOfBusiness === "") {
      objErrors.typeOfBusiness = "Type of Business is required";
    } else {
      objErrors = {};
    }
    return objErrors;
  };

  const handleSendOtp = async () => {
    await sendOtpAndRegister()
      .then((res) => {
        toast({
          title: "Otp Sent Success",
          description: `Otp Sent on your phone : ${config.phone}!!`,
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        console.log(res);
      })
      .catch((err) => {
        toast({
          title: "Error in Sending Otp ",
          description: err?.error ?? "Internal Server Error!",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        console.log(err);
        throw err;
      });
  };
  const handleRegister = async () => {
    if (step === 1) {
      const objErrors = { ...errors, ...validateStepOne(config) };
      if (Object.keys(objErrors).length > 0) {
        console.log("objErrors", objErrors);
        setErrors(objErrors);
        toast({
          title: "Form Field Errors",
          description: "Please fill the fields correctly!",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      } else {
        await handleSendOtp()
          .then(() => {
            setStep(step + 1);
          })
          .catch((err) => {
            console.log("handleSendOtp Error :", err.error);
          });
      }
    }
    if (step === 2) {
    }
  };

  useEffect(() => {
    setResendTimer(60);
  }, [config.phone, config.description]);

  return (
    <>
      {step === 1 ? (
        <RegisterUser
          handleClick={handleClick}
          onChange={onChange}
          config={config}
          show={show}
          handleRegister={handleRegister}
          sendOtpAndRegister={sendOtpAndRegister}
          errors={errors}
          setErrors={setErrors}
        />
      ) : (
        <VerifyOtp
          handleClick={handleClick}
          onChange={onChange}
          config={config}
          show={show}
          handleRegister={handleRegister}
          handleGoBack={handleGoBack}
          resendTimer={resendTimer}
          setResendTimer={setResendTimer}
          sendOtpAndRegister={sendOtpAndRegister}
          resendOtp={resendOtp}
          errors={errors}
          setErrors={setErrors}
        />
      )}
    </>
  );
}
